document.addEventListener('DOMContentLoaded', () => {
	const tabsContainers = document.querySelectorAll('.widget-tabs');

	tabsContainers.forEach((container) => {
		const tabs = container.querySelectorAll('.tab');
		const tabContents = container.querySelectorAll('.tab-content');
		const firstTab = tabs[0];
		const firstTabContent = tabContents[0];

		if (firstTabContent) {
			firstTabContent.classList.add('is-active');
		}

		if (firstTab) {
			firstTab.classList.add('is-active');
		}

		tabs.forEach((tab, index) => {
			tab.addEventListener('click', () => {
				tabContents.forEach((content) => {
					content.classList.remove('is-active');
				});

				const clickedTabContent = tabContents[index];
				if (clickedTabContent) {
					clickedTabContent.classList.add('is-active');
				}

				tabs.forEach((t) => {
					t.classList.remove('is-active');
				});

				tab.classList.add('is-active');
			});
		});
	});
});
